<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz24-1"><a id="page_12"></a><a href="#/contents#RR_23" id="CC_23"> Mayberry Molasses Bread</a></p>
<p class="tx6" id="pz24-2"><i> It’s slow good. </i></p>
<p class="tx5" id="pAxN"><b> 1 cup whole-wheat flour </b></p>
<p class="tx5" id="pAFqW"><b> 1 cup all-purpose flour </b></p>
<p class="tx5" id="pAn82"><b> 1 teaspoon baking soda </b></p>
<p class="tx5" id="pA2b"><b> 1 teaspoon salt </b></p>
<p class="tx5" id="pAZDX"><b> ½ cup sugar </b></p>
<p class="tx5" id="pAHL"><b> ½ cup dark molasses </b></p>
<p class="tx5" id="pAkMp"><b> 1½ cups milk (do not use skim) </b></p>
<p class="tx1" id="pAEB"><span class="dcap">P</span>reheat the oven to 325°. Spray a 9×4-inch loaf pan with cooking spray. Sift together dry ingredients. Mix liquid ingredients; then add to dry mixture. Mix well with electric mixer. Pour into greased loaf pan. Bake for 1½ hours. Cool for 10 minutes in pan; then turn out and allow to cool completely. Delicious with cream cheese.</p>
<p class="tx" id="pAh_"> Freezes well.</p>
<p class="tx" id="pAZOJ"> Makes 1 loaf.</p>
<p class="txrr" id="pAR16"> <i>Annette Davis—Greensboro, North Carolina</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter23.vue?6bda2cb4